import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FormattedCommaSeparatedValue } from "@MasterBluePrint/Services/FormattedValueService";

import translate from "@insite/client-framework/Translate";

import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    multipleSaleQty?: string;
}

export interface MsqStyles {
    msqContainer: InjectableCss;
}

export const msqStyles: MsqStyles = {
    msqContainer: {
        css: css``,
    },
};

const Msq: FC<OwnProps> = ({ multipleSaleQty }) => {
    if(!multipleSaleQty)
    {
        return null;
    }
    const normalizedQty = parseFloat(multipleSaleQty.replace(/,/g,""));
    const isValidQty = normalizedQty > 1;

    return (
        <>
        <StyledWrapper {...msqStyles.msqContainer}>
            {isValidQty ? (
                <Typography style={{ display: "block" }}>
                    {translate("Multiples of: {0}", FormattedCommaSeparatedValue(normalizedQty.toString()))}
                </Typography>
            ) : ""}
            </StyledWrapper>
        </>
    );
};
export default Msq;
